// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__GmIKv","heroContainer":"Hero_heroContainer__d9BWz"};